// A "Ducks"-style collection
// https://github.com/erikras/ducks-modular-redux

// Action Types
export const typePrefix = 'vra/operations/';
export const actions = [
  'SET_ALL_OPERATIONS'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducer

export default function reducer(
  state = {},
  action = {}
) {
  switch (action.type) {
    case actions.SET_ALL_OPERATIONS:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
}

// Action Creators

export const setAllOperations = (farms) => {
  return {
    type: actions.SET_ALL_OPERATIONS,
    payload: farms
  };
};
